import { useMutation } from '@tanstack/react-query';
import { duplicateGoal } from 'shared/services/backend-api';
import { Goal } from 'shared/types/goal';

export const useDuplicateGoalMutation = () =>
  useMutation({
    mutationFn: async (goal: Goal) => duplicateGoal(goal),
  });
